import { render, staticRenderFns } from "./UpgradeScript.vue?vue&type=template&id=25ae85dc&scoped=true&"
import script from "./UpgradeScript.vue?vue&type=script&lang=js&"
export * from "./UpgradeScript.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeScript.vue?vue&type=style&index=0&id=25ae85dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae85dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
